import { createSlice } from '@reduxjs/toolkit';

const driverOnCallSlice = createSlice({
  name: 'driverOnCall',
  initialState: {
    driverOnCallPackageData: {},
    driverOnCallPackageDataIsLoading: false,
    driverOnCallPackageDataErrorMsg: null,

    drivingOnCallPackageBuyData: {},
    drivingOnCallPackageBuyIsLoading: false,
    drivingOnCallPackageBuyErrorMsg: null,

    customerCallListData: [],
    customerCallListDataIsLoading: false,
    customerCallListDataErrorMsg: null,
  },
  reducers: {
    driverOnCallPackageReq: (state, action) => { },
    driverOnCallPackageSuccess: (state, action) => ({
      ...state,
      driverOnCallPackageData: action.payload,
      driverOnCallPackageDataIsLoading: false,
      driverOnCallPackageDataErrorMsg: null,
    }),
    driverOnCallPackageFailure: (state, action) => ({
      ...state,
      driverOnCallPackageDataIsLoading: false,
      driverOnCallPackageDataErrorMsg: action.payload,
    }),
    driverOnCallPackageLoading: (state) => ({
      ...state,
      driverOnCallPackageDataIsLoading: true,
      driverOnCallPackageDataErrorMsg: null,
    }),
    driverOnCallPackageClear: (state) => ({
      ...state,
      driverOnCallPackageData: {},
      driverOnCallPackageDataIsLoading: false,
      driverOnCallPackageDataErrorMsg: null,
    }),

    drivingOnCallPackageBuyReq: (state, action) => { },
    drivingOnCallPackageBuySuccess: (state, action) => ({
      ...state,
      drivingOnCallPackageBuyData: action.payload,
      drivingOnCallPackageBuyIsLoading: false,
      drivingOnCallPackageBuyErrorMsg: null,
    }),
    drivingOnCallPackageBuyFailure: (state, action) => ({
      ...state,
      drivingOnCallPackageBuyIsLoading: false,
      drivingOnCallPackageBuyErrorMsg: action.payload,
    }),
    drivingOnCallPackageBuyLoading: (state) => ({
      ...state,
      drivingOnCallPackageBuyIsLoading: true,
      drivingOnCallPackageBuyErrorMsg: null,
    }),
    drivingOnCallPackageBuyClear: (state) => ({
      ...state,
      drivingOnCallPackageBuyData: {},
      drivingOnCallPackageBuyIsLoading: false,
      drivingOnCallPackageBuyErrorMsg: null,
    }),

    customerCallListReq: (state, action) => { },
    customerCallListSuccess: (state, action) => ({
      ...state,
      customerCallListData: action.payload,
      customerCallListDataIsLoading: false,
      customerCallListDataErrorMsg: null,
    }),
    customerCallListFailure: (state, action) => ({
      ...state,
      customerCallListDataIsLoading: false,
      customerCallListDataErrorMsg: action.payload,
    }),
    customerCallListLoading: (state) => ({
      ...state,
      customerCallListDataIsLoading: true,
      customerCallListDataErrorMsg: null,
    }),
    customerCallListClear: (state) => ({
      ...state,
      customerCallListData: [],
      customerCallListDataIsLoading: false,
      customerCallListDataErrorMsg: null,
    }),
  },
});

export const {
  driverOnCallPackageClear,
  driverOnCallPackageFailure,
  driverOnCallPackageLoading,
  driverOnCallPackageReq,
  driverOnCallPackageSuccess,

  drivingOnCallPackageBuyClear,
  drivingOnCallPackageBuyFailure,
  drivingOnCallPackageBuyLoading,
  drivingOnCallPackageBuyReq,
  drivingOnCallPackageBuySuccess,

  customerCallListClear,
  customerCallListFailure,
  customerCallListLoading,
  customerCallListReq,
  customerCallListSuccess,
} = driverOnCallSlice.actions;

export default driverOnCallSlice.reducer;
